<template>
  <div v-if="platform2 == ''"></div>
  <router-view v-else-if="platform2 == 'mobile'"/>
  <div
    class="flex flex-center column q-gutter-y-md"
    style="height: 90vh"
    v-else
  >

    <q-icon name="phone_iphone" size="80px"/>
    <div class="text-weight-bold">برجاء زيارة الموقع من الهاتف المحمول</div>

  </div>
</template>

<script>
import { authStore } from "@/store/auth.store";
import router from "@/router";
import { chackLoginAction } from "@/action/auth.action";
import { useQuasar } from 'quasar'
export default {
  name: "LayoutDefault",
  data(){
    return{
      platform2:"",
      store:authStore()
    }
  },
  methods:{
    platform(){
      const $q = useQuasar()
      if($q.platform.is.mobile) this.platform2 = "mobile"
      else this.platform2 = "desktop"
      // else this.platform2 = "mobile"
    }
  },
  mounted() {
    this.platform()
    const user = localStorage.getItem('user') || null
    if(user == null && window.location.pathname != "/")
      router.push("/")
    else if(user != null && window.location.pathname == "/") {
      router.push("/home")
      this.store.user = JSON.parse(localStorage.getItem('user'))
    }
    else {
      this.store.user = JSON.parse(localStorage.getItem('user'))
    }

    if(user != null) chackLoginAction(this.store.user.password)
  }
};
</script>
